<script setup lang="ts">
/**
 * En-tête d'écran.
 * - Téléphone : grand titre sous la barre d'actions (écrans principaux) ; titre compact centré
 *   avec retour (écrans secondaires). Respecte l'encoche (safe area).
 * - Ordinateur : titre et actions sur une seule ligne, alignés à gauche.
 * Un seul titre est affiché à la fois (l'autre est retiré de l'arbre d'accessibilité).
 */
import { fr } from '@/copy/fr'

import IconButton from './IconButton.vue'

withDefaults(defineProps<{ title: string; back?: boolean; large?: boolean }>(), {
  back: false,
  large: false,
})

defineEmits<{ back: [] }>()
</script>

<template>
  <header class="sticky top-0 z-30 bg-bg pt-safe lg:static">
    <div class="flex h-14 items-center gap-2 px-2 lg:h-16 lg:px-gutter">
      <IconButton v-if="back" icon="back" :label="fr.ui.back" @click="$emit('back')" />
      <span v-else class="w-2 lg:hidden" aria-hidden="true" />
      <h1 v-if="large" class="hidden min-w-0 flex-1 truncate text-title text-ink lg:block">
        {{ title }}
      </h1>
      <span v-if="large" class="flex-1 lg:hidden" aria-hidden="true" />
      <h1
        v-else
        class="min-w-0 flex-1 truncate text-center text-section text-ink lg:text-left lg:text-title"
      >
        {{ title }}
      </h1>
      <div class="flex min-w-touch items-center justify-end gap-1">
        <slot name="actions" />
      </div>
    </div>
    <h1 v-if="large" class="px-gutter pb-2 text-title text-ink lg:hidden">{{ title }}</h1>
  </header>
</template>
